/*
  POUFF full-screen newsletter popup (design spec: 4a desktop / 4b mobile).

  Trigger/teaser/success-step logic for the full-screen popup specifically.
  Suppression, the cross-popup mutex, and Klaviyo event tracking are shared
  with the corner popup via assets/pouff-newsletter-shared.js — see that
  file for why.

  The actual Klaviyo subscribe call is NOT here; see
  assets/pouff-newsletter-popup.js's header comment (same pattern, same
  reasoning) for how assets/pouff-klaviyo.js handles it.
*/
(function () {
  var ROOT_SELECTOR = '[data-pouff-fullscreen-popup]';
  var EMAIL_RE = /^\S+@\S+\.\S+$/;

  function init(root) {
    var shared = window.PouffNewsletterPopups;
    if (!shared) return;

    var delaySeconds = parseInt(root.getAttribute('data-delay-seconds'), 10);
    if (isNaN(delaySeconds)) delaySeconds = 1;
    var maxShows = parseInt(root.getAttribute('data-max-shows'), 10) || 3;

    var panel = root.querySelector('.pouff-fullscreen-popup__panel');
    var teaser = root.querySelector('[data-pouff-fullscreen-popup-teaser]');
    var formStep = root.querySelector('[data-pouff-fullscreen-popup-step="form"]');
    var successStep = root.querySelector('[data-pouff-fullscreen-popup-step="success"]');
    var form = root.querySelector('[data-pouff-fullscreen-popup-form]');
    var emailInput = root.querySelector('[data-pouff-fullscreen-popup-email]');
    var formatError = root.querySelector('[data-pouff-fullscreen-popup-format-error]');
    var statusEl = root.querySelector('[data-pouff-klaviyo-status]');
    var closeButtons = root.querySelectorAll('[data-pouff-fullscreen-popup-close]');

    if (!panel || !form || !emailInput) return;

    var companyId = form.getAttribute('data-pouff-klaviyo-company');

    function showPanel() {
      if (!shared.claim()) return false;
      root.hidden = false;
      panel.hidden = false;
      teaser.hidden = true;
      document.documentElement.style.overflow = 'hidden';
      shared.trackEvent(companyId, 'Viewed fullscreen popup');
      window.requestAnimationFrame(function () {
        root.setAttribute('data-pouff-fullscreen-popup-open', '');
      });
      return true;
    }

    // Only the automatic first-load show counts toward maxShows; reopening
    // from the teaser tab does not.
    function autoShow() {
      if (showPanel()) shared.recordFullscreenShow();
    }

    function hidePanel() {
      root.removeAttribute('data-pouff-fullscreen-popup-open');
      document.documentElement.style.overflow = '';
      shared.release();
      window.setTimeout(function () {
        panel.hidden = true;
      }, 250);
    }

    function showTeaser() {
      hidePanel();
      root.hidden = false;
      teaser.hidden = false;
    }

    // Closing does not suppress anything: this popup keeps coming back once
    // per session until maxShows is used up, then the corner popup takes over.
    function closeToTeaser() {
      showTeaser();
    }

    function reopenFromTeaser() {
      formStep.hidden = false;
      successStep.hidden = true;
      showPanel();
    }

    function showSuccessStep() {
      formStep.hidden = true;
      successStep.hidden = false;
      shared.trackEvent(companyId, 'Subscribed via fullscreen popup');
      shared.markSubscribed();
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeToTeaser);
    });

    teaser.addEventListener('click', reopenFromTeaser);

    emailInput.addEventListener('input', function () {
      formatError.hidden = true;
    });

    form.addEventListener('submit', function (event) {
      if (!EMAIL_RE.test(emailInput.value.trim())) {
        event.preventDefault();
        event.stopImmediatePropagation();
        formatError.hidden = false;
      }
    });

    if (statusEl) {
      var observer = new MutationObserver(function () {
        var text = statusEl.textContent || '';
        var isError = statusEl.hasAttribute('data-pouff-klaviyo-error');
        if (text && !isError) {
          showSuccessStep();
        }
      });
      observer.observe(statusEl, { childList: true, characterData: true, subtree: true });
    }

    // Review aid: ?popup=fullscreen shows this popup immediately, ignoring
    // suppression, and the corner popup stays out of the way (see its JS).
    if (/[?&]popup=fullscreen(&|$)/.test(window.location.search)) {
      window.setTimeout(showPanel, 300);
      return;
    }

    if (
      shared.onCartPage() ||
      shared.isSubscribed() ||
      shared.fullscreenShownThisSession() ||
      shared.getFullscreenShows() >= maxShows
    ) {
      return;
    }

    window.setTimeout(autoShow, delaySeconds * 1000);
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(init);
})();
